<template>
  <div class="tile is-child notification is-danger box">
    <div class="columns">
      <div class="column">
        <p class="subtitle"><AccountMultiple />&nbsp;{{ signups }} Signups</p>
      </div>
      <div class="column">
        <p class="subtitle"><CheckboxMarked />&nbsp;{{ completed }} Completed ({{ rate }}%)</p>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <router-link
          :to="{ name: 'admin-users', query: { type: 'participant' } }"
          class="widget-action"
        >
          Participants<span>&nbsp;<Settings /></span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import AccountMultiple from 'vue-material-design-icons/AccountMultiple.vue'
import CheckboxMarked from 'vue-material-design-icons/CheckboxMarked.vue'
import Settings from 'vue-material-design-icons/Settings.vue'

export default {
  name: 'ParticipantWidget',
  components: {
    AccountMultiple,
    CheckboxMarked,
    Settings
  },
  data () {
    return {
      signups: 0,
      completed: 0,
      rate: 0
    }
  },
  mounted () {
    this.$store
      .dispatch('users/GET_USERS', { type: 'participant' })
      .then(res => {
        let participants = []
        let paid = []

        res.data.users.map(u => {
          if (u.role === 'participant') {
            participants.push(u)
          }
          if (u.completedPayment) {
            paid.push(u)
          }
        })

        this.signups = participants.length
        this.completed = paid.length
        this.rate = Math.round(this.completed / this.signups * 1000) / 10
      })
  }
}
</script>
